"use strict";

const _ = require('lodash');
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./GridRowRenderer");

class GridRowComponent extends EventEmitter {

    constructor(configOptions) {
        super();

        this._id = _.get(configOptions, 'id', undefined);
        this._rowData = _.get(configOptions, 'rowData', {});
        this._columnOrder = _.get(configOptions, 'columnOrder');
        this._columnComponents = _.get(configOptions, 'columnComponents');
        this._selected = _.get(configOptions, 'selected');
        
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        return this._renderer._shutdown()
            .then(()=>{
                this._renderer = undefined;
                this._id = undefined;
                this._rowData = undefined;
                this._columnOrder = undefined;
                this._columnComponents = undefined;
                this._selected = undefined;
            });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    
    _triggerRowUserSelected(event){
        this.emit('RowUserSelected', this._rowData, event);
    }

    _triggerRowUserDoubleClicked(event){
        this.emit('RowUserDoubleClicked', this._rowData, event);
    }

    _triggerRowAction(eventData){
        let rowEvent = {
            rowId: this.getId(),
            eventData: eventData
        };
        this.emit('RowAction', rowEvent);
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setId(newVal){
        this._id = newVal;
        this.emit('ID', this._id);
        return this;
    }
    getId(){
        return this._id;
    }

    setRowData(newVal){
        this._rowData = newVal;
        this.emit('RowData', this._rowData);
        return this;
    }
    getRowData(){
        return this._rowData;
    }

    setColumnOrder(newVal){
        this._columnOrder = newVal;
        this.emit('ColumnOrder', this._columnOrder);
        return this;
    }
    getColumnOrder(){
        return this._columnOrder;
    }

    setColumnComponents(newVal){
        this._columnComponents = newVal;
        this.emit('ColumnComponents', this._columnComponents);
        return this;
    }
    getColumnComponents(){
        return this._columnComponents;
    }

    setSelected(newVal){
        this._selected = newVal;
        this.emit('Selected', this._selected);
        return this;
    }
    getSelected(){
        return this._selected;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = GridRowComponent;